<!--选择excel文件并上传页面-->
<template>
  <div class="import-excel-page">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row class="main-content">
      <el-col :span="4" class="menu-col">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20" class="content-col">
        <!-- 页面标题 -->
        <div class="page-header">
          <div class="header-icon">📊</div>
          <div class="header-text">
            <h2>导入Excel表格</h2>
            <p>导入表头制成空白表格，快速开始数据收集</p>
          </div>
        </div>

        <!-- 主要操作区 -->
        <div class="upload-card" style="display: flex;justify-content: center;flex-direction: column;">
          <!-- 警告提示 -->
          <div class="warning-banner">
            <i class="el-icon-warning"></i>
            <span>如果上传失败，请将文件另存为"Microsoft Excel 97-2003文件(*.xls)"格式后再上传</span>
          </div>

          <!-- 上传区域 -->
          <div class="upload-area">
            <el-form ref="editForm" :model="editForm" size="medium" class="upload-form">
              <el-form-item class="upload-form-item">
                <div class="upload-wrapper">
                  <el-upload
                    class="upload-demo"
                    :http-request="uploadFile"
                    action
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-change="fileChange"
                    :before-remove="beforeRemove"
                    accept=".xls,.xlsx"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    drag>
                    <div class="upload-content">
                      <i class="el-icon-upload"></i>
                      <div class="upload-text">
                        <span class="primary-text">点击或拖拽Excel文件到此处</span>
                        <span class="secondary-text">支持 .xls 和 .xlsx 格式，文件大小不超过10M</span>
                      </div>
                    </div>
                  </el-upload>
                </div>

                <!-- 文件列表 -->
                <div class="file-actions" v-show="fileList.length>0">
                  <div class="file-info">
                    <i class="el-icon-document"></i>
                    <span>已选择 {{fileList.length}} 个文件</span>
                  </div>
                  <el-button class="btn-delete" plain @click="emptyFileList">
                    <i class="el-icon-delete"></i> 删除文件
                  </el-button>
                </div>
              </el-form-item>

              <!-- 操作按钮组 -->
              <el-form-item class="action-buttons">
                <el-tooltip effect="dark" content="查看导入前的重要说明" placement="top">
                  <el-button class="btn-secondary-custom" @click="showUse">
                    <i class="el-icon-reading"></i> 导入必读
                  </el-button>
                </el-tooltip>

                <el-tooltip effect="dark" content="请不要使用IE浏览器。其他浏览器如果点击无反应，请切换为'高速模式'后重新登录再试试" placement="top">
                  <el-button class="btn-primary-custom" @click="uploadExcelFile" :disabled="fileList.length===0">
                    <i class="el-icon-right"></i> 下一步
                  </el-button>
                </el-tooltip>
              </el-form-item>
            </el-form>
          </div>

          <!-- 提示信息 -->
          <div class="help-section">
            <div class="help-item" @click="howToSwitch">
              <i class="el-icon-question"></i>
              <span>如何将浏览器切换成"高速模式"或"快速模式"</span>
            </div>
            <div class="help-item highlight" @click="openWanSearch">
              <i class="el-icon-search"></i>
              <span>如果将导入的数据用于查询，请使用<span class="highlight-text">万能查询</span></span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 浏览器模式切换弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="browserSwitchDialogVisible" custom-class="custom-dialog" width="700px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-question"></i>
        <span>如何切换浏览器的模式</span>
      </div>
      <div class="dialog-body">
        <div class="instruction-step">
          <span class="step-num">1</span>
          <span>找到浏览器地址栏右侧的图标（如下图所示红色框部分）</span>
        </div>
        <div class="instruction-image">
          <img src="../assets/switch_browser.png" />
        </div>
        <div class="instruction-step">
          <span class="step-num">2</span>
          <span>点击切换到闪电图标或"极速模式"/"高速模式"</span>
        </div>
        <div class="instruction-image">
          <img src="../assets/good_browser.png" />
        </div>
        <div class="instruction-tip">
          <i class="el-icon-info"></i>
          <span>切换完成后请刷新页面重新登录</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 检查表格弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="checkFormDialogVisible" custom-class="custom-dialog" width="600px">
      <div slot="title" class="dialog-title warning">
        <i class="el-icon-warning"></i>
        <span>表格不能有合并的单元格</span>
      </div>
      <div class="dialog-body">
        <div class="notice-box">
          <p>为了方便核查数据，以及减少导入过程中出错的可能性，<strong>请将表格中合并单元格全部取消后再导入</strong>。</p>
          <div class="divider"></div>
          <div class="solution">
            <h4>取消合并单元格的方法：</h4>
            <ol>
              <li>选中包含合并单元格的区域</li>
              <li>点击"合并单元格"按钮取消合并</li>
              <li>取消后如有空白单元格，请填充好数据，方便后期确认</li>
            </ol>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFormDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

    <!-- 导入必读弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="mustReadDialogVisible" custom-class="custom-dialog" width="700px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-reading"></i>
        <span>表格导入必读</span>
      </div>
      <div class="dialog-body">
        <div class="qa-list">
          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>适合导入什么样的表格？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>适合导入<strong>首行是表头，每行是填表人需要填写数据</strong>的表格；如果是复杂表格，请自行设计成首行是表头的表格后再导入。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况下使用导入表格功能？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>一种情况是您有表格，手机端制作录入麻烦，可以用导入；另一种情况是需要填表人修改您excel表格里的数据，比如修订已有数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况导入空表？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>需要填表人填表时导入空表。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>在什么情况导入数据？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>需要填表人修改您excel表格上的数据时导入数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <span class="qa-badge q">Q</span>
              <span>表头特别复杂怎么导入？</span>
            </div>
            <div class="qa-answer">
              <span class="qa-badge a">A</span>
              <span>导入表格要观察列，因为一个列是一个数据，所以这个列叫什么就给这个列取什么名字。列名可以在预览界面点击单元格选择，可以减少输入量。</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-primary-custom" @click="mustReadDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!-- 万能快查弹窗 -->
    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="wanSearchDialogVisible" custom-class="custom-dialog" width="400px">
      <div slot="title" class="dialog-title">
        <i class="el-icon-magic-stick"></i>
        <span>万能快查，发啥查啥</span>
      </div>
      <div class="dialog-body center">
        <div class="qrcode-box">
          <img :src="qr_wansearch_url" class="qrcode-img" />
          <p class="qrcode-tip">微信扫码打开万能快查小程序</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wanSearchDialogVisible=false">知道了</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        },

        checkFormDialogVisible: false,
        mustReadDialogVisible: false,

        wanSearchDialogVisible: false,

        qr_wansearch_url: '/form/images/wansearch_qrcode.jpg'
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {},
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let tmpCheckFile = this.fileList[0].raw
        if (tmpCheckFile && tmpCheckFile.size / 1024 / 1024 >= 10) {
          this.$message.error('上传的Excel文件大小不能超过10M!')
          this.emptyFileList()
          return
        }

        let that = this

        let data = new FormData()
        data.set('username', this.username)

        let tmpExcelFile = this.fileList[0].raw

        data.append('file', tmpExcelFile)

        const load = this.$loading({
          lock: true,
          text: '正在上传文件...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_upload_data_excel_for_preview.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          if (res.data.result === '1') {
            var uploaded_excel_file_name = res.data.excel_file
            that.$router.push({
                name: 'excel_data_preview',
                params: {
                  username: that.username,
                  excel_file: uploaded_excel_file_name
                }
              })
          }
          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()
          that.$router.push('/import_data_excel')
        })
      },

      fileChange(file, fileList) {
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error('上传的Excel文件大小不能超过10M!')
          this.fileList = []
          return false
        }
        this.fileList = fileList
        return true
      },
      back() {
        this.$router.push('/validation_form_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      showUse() {
        this.mustReadDialogVisible = true
      },
      openWanSearch() {
        this.wanSearchDialogVisible = true
      }

    }
  }
</script>

<style scoped>
  /* 页面整体布局 */
  .import-excel-page {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content {
    padding: 20px;
  }

  .menu-col {
    padding-right: 20px;
  }

  .content-col {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.06);
    padding: 30px;
    min-height: calc(100vh - 140px);
  }

  /* 页面标题 */
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .header-icon {
    font-size: 48px;
    margin-right: 20px;
  }

  .header-text h2 {
    font-size: 24px;
    color: #1a1a1a;
    margin: 0 0 6px;
    font-weight: 600;
  }

  .header-text p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 上传卡片 */
  .upload-card {
    max-width: 800px;
    margin: 0 auto;
  }

  /* 警告横幅 */
  .warning-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%);
    border-left: 4px solid #FFCB2F;
    border-radius: 8px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #8b6914;
  }

  .warning-banner i {
    font-size: 18px;
    color: #FFCB2F;
  }

  /* 上传区域 */
  .upload-area {
    margin-bottom: 30px;
  }

  /* 上传表单 */
  .upload-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .upload-form-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .upload-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
    height: 220px;
    border: 2px dashed #dcdfe6;
    border-radius: 12px;
    background: #fafbfc;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  ::v-deep .el-upload-dragger:hover {
    border-color: #1485FB;
    background: #f0f7ff;
  }

  ::v-deep .el-upload-dragger .el-upload__text {
    text-align: center;
    width: 100%;
  }

  .upload-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    text-align: center;
  }

  .upload-content i {
    font-size: 48px;
    color: #1485FB;
    margin-bottom: 16px;
  }

  .upload-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .primary-text {
    font-size: 16px;
    color: #1a1a1a;
    font-weight: 500;
  }

  .secondary-text {
    font-size: 13px;
    color: #999;
  }

  /* 文件操作 */
  .file-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    padding: 16px 20px;
    background: #f8f9fa;
    border-radius: 8px;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .file-info {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #555;
    font-size: 14px;
  }

  .file-info i {
    font-size: 20px;
    color: #1485FB;
  }

  .btn-delete {
    border-color: #ff4d4f;
    color: #ff4d4f;
  }

  .btn-delete:hover {
    background: #fff1f0;
    border-color: #ff4d4f;
    color: #ff4d4f;
  }

  /* 操作按钮组 */
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-primary-custom {
    padding: 12px 32px;
    font-size: 15px;
    border-radius: 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.35);
    background: linear-gradient(135deg, #2d91fb 0%, #1a7cff 100%);
  }

  .btn-primary-custom:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  .btn-secondary-custom {
    padding: 12px 32px;
    font-size: 15px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #555;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .btn-secondary-custom:hover {
    border-color: #1485FB;
    color: #1485FB;
    background: #f0f7ff;
  }

  /* 帮助区域 */
  .help-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .help-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    color: #555;
  }

  .help-item:hover {
    background: #e6f7ff;
    color: #1485FB;
  }

  .help-item i {
    font-size: 16px;
  }

  .help-item.highlight {
    background: #fff7e6;
  }

  .help-item.highlight:hover {
    background: #ffe7ba;
  }

  .highlight-text {
    color: #ff6b6b;
    font-weight: 600;
  }

  /* ==================== 弹窗样式 ==================== */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 0;
  }

  .dialog-title {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  .dialog-title i {
    font-size: 20px;
  }

  .dialog-title.warning {
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4d4f 100%);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn {
    top: 20px;
    right: 20px;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .custom-dialog .el-dialog__body {
    padding: 30px;
  }

  ::v-deep .custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 20px 30px;
  }

  .dialog-body {
    max-height: 500px;
    overflow-y: auto;
  }

  .dialog-body.center {
    text-align: center;
  }

  /* 步骤说明 */
  .instruction-step {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 15px;
    font-size: 14px;
    color: #555;
  }

  .step-num {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
  }

  .instruction-image {
    margin: 15px 0 25px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }

  .instruction-image img {
    width: 100%;
    display: block;
  }

  .instruction-tip {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #e6f7ff;
    border-radius: 8px;
    font-size: 13px;
    color: #1485FB;
  }

  /* 提示框 */
  .notice-box {
    font-size: 14px;
    line-height: 1.8;
    color: #555;
  }

  .notice-box p {
    margin: 0 0 15px;
  }

  .divider {
    height: 1px;
    background: #f0f0f0;
    margin: 20px 0;
  }

  .solution h4 {
    font-size: 15px;
    color: #1a1a1a;
    margin: 0 0 12px;
  }

  .solution ol {
    margin: 0;
    padding-left: 20px;
    color: #666;
  }

  .solution li {
    margin-bottom: 8px;
  }

  /* Q&A 列表 */
  .qa-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .qa-item {
    padding: 20px;
    background: #f8f9fa;
    border-radius: 12px;
    border-left: 3px solid #1485FB;
  }

  .qa-question {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 12px;
  }

  .qa-answer {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  .qa-badge {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .qa-badge.q {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
  }

  .qa-badge.a {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
  }

  /* 二维码区域 */
  .qrcode-box {
    padding: 20px;
  }

  .qrcode-img {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  }

  .qrcode-tip {
    margin-top: 15px;
    font-size: 14px;
    color: #888;
  }

  /* 响应式 */
  @media (max-width: 1200px) {
    .main-content {
      padding: 15px;
    }

    .content-col {
      padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/import_data_excel.vue